import { mapBrazeCardsToCarouselCards } from 'features/home/HomeScreen/adapters/mapMarketingCarousel/mapMarketingCarousel';
import { useMemo } from 'react';
import { FlatList, StyleSheet, View } from 'react-native';
import { BrazeContentCard } from 'services/engagement/braze/types';
import VXLMarketingCard from 'shared/components/vxl/cards/VXLMarketingCard/VXLMarketingCard';
import theme from 'shared/styles/theme';

const CARD_WIDTH = 300;
const SEPARATOR_WIDTH = 8;
const SNAP_INTERVAL = CARD_WIDTH + SEPARATOR_WIDTH;

export interface MarketingCardCarouselProps {
  contentCards: BrazeContentCard[];
  onCardClick: (card: BrazeContentCard) => void;
}

const MarketingCardCarousel = ({
  contentCards,
  onCardClick,
}: MarketingCardCarouselProps) => {
  const cards = useMemo(() => {
    return mapBrazeCardsToCarouselCards(contentCards);
  }, [contentCards]);

  return (
    <FlatList
      data={cards}
      renderItem={({ item }) => (
        <VXLMarketingCard
          labelText={item.labelText}
          headlineText={item.headlineText}
          illustration={item.illustration}
          colorTheme={item.colorTheme}
          onPress={() => {
            onCardClick(item.sourceCard);
          }}
        />
      )}
      keyExtractor={(item) => item.id}
      horizontal
      contentContainerStyle={styles.listContent}
      ItemSeparatorComponent={() => <View style={styles.separator} />}
      snapToInterval={SNAP_INTERVAL}
      decelerationRate="fast"
      showsHorizontalScrollIndicator={false}
    />
  );
};
const styles = StyleSheet.create({
  listContent: {
    paddingLeft: theme.spacing.m,
  },
  separator: {
    width: SEPARATOR_WIDTH,
  },
});
export default MarketingCardCarousel;
